import { modalComponentModule } from '../../../../shared/app/components/modal/modal';
import resetAssessmentDialogTemplate from './reset-assessment-dialog.tpl.html';
import './reset-animation-dialog.less';
import { appAlertComponentModule } from '../../../../shared/app/components/app-alert/app-alert';

export const resetAssessmentComponentModule = angular
  .module('Q.components.reset-assessment-dialog', [
    modalComponentModule,
    appAlertComponentModule,
  ])

  .factory('resetAssessmentDialog', function resetAssessmentDialog($modal) {
    return {
      open(assessmentResultProcess, autoOpened) {
        return $modal.openOnce('resetAssessmentDialog', {
          template: resetAssessmentDialogTemplate,
          controller: 'ResetAssessmentDialogCtrl as $ctrl',
          resolve: {
            assessmentResultProcess: () => assessmentResultProcess,
            autoOpened: () => autoOpened,
          },
        }).result;
      },
    };
  })
  .controller(
    'ResetAssessmentDialogCtrl',
    function ResetAssessmentDialogCtrl(
      $modalInstance,
      assessmentResultProcess,
      autoOpened,
      appAlert,
      $document,
      $window,
      $state,
    ) {
      const ctrl = this;

      ctrl.cancel = () => $modalInstance.dismiss();

      ctrl.isSubmitted = assessmentResultProcess.isFinished();
      ctrl.isOutdated =
        !assessmentResultProcess.assessmentResult.isSnapshotCurrent();
      ctrl.autoOpened = autoOpened;

      ctrl.fullResetOnly = !(
        ctrl.isSubmitted ||
        ctrl.isOutdated ||
        ctrl.autoOpened
      );

      const toggleProcessing = (processing) => {
        ctrl.processing = processing;
        $document.querySelector('#app').css('opacity', processing ? 0 : null);
      };

      const catchResetError = (resp) => {
        toggleProcessing(false);
        ctrl.cancel();
        return appAlert.modelError(resp);
      };

      const completeReset = () => {
        // forces a reload back to welcome
        $window.location.href = $state.href('assessments.welcome');
      };

      ctrl.continue = () => {
        if (ctrl.processing) return;
        if (ctrl.isSubmitted) {
          toggleProcessing(true);
          assessmentResultProcess
            .restart()
            .catch(catchResetError)
            .then(completeReset);
        } else {
          ctrl.cancel();
        }
      };

      ctrl.reset = (resetAll) => {
        if (ctrl.processing) return;
        toggleProcessing(true);
        assessmentResultProcess
          .reset(resetAll)
          .catch(catchResetError)
          .then(completeReset);
      };
    },
  );
